import { render, staticRenderFns } from "./rank-value.vue?vue&type=template&id=0b0d598a&scoped=true&"
import script from "./rank-value.vue?vue&type=script&lang=js&"
export * from "./rank-value.vue?vue&type=script&lang=js&"
import style0 from "./rank-value.vue?vue&type=style&index=0&id=0b0d598a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d598a",
  null
  
)

export default component.exports